import React from 'react'
import styles from './FullWidthImage.scss'
import {findDOMNode} from 'react-dom'
import {getConsole} from 'lib/getConsole'
import _ from 'lodash'
const console = getConsole('rr', 'FullWidthImage')

export class FullWidthImage extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      yCenter: isFinite(props.yCenter) ? props.yCenter : 0.5,
      dragging: false,
      aspect: 1,
      rel: {
        yPrime: null,
        yCenterPrime: null
      },
      // vw used to trigger updates, not used in calculation since invoking
      // window.innerWidth directly is more accurate
      vw: window.innerWidth
    }
    this._throttledOnResize = _.throttle(this.onResize, 50)
  }

  componentDidMount () {
    window.addEventListener('resize', this._throttledOnResize)
    if (this._img && this._img.complete) {
      this.setAspect()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this._throttledOnResize)
  }

  onResize = () => {
    console.log('onResize')
    this.setState({vw: window.innerWidth})
  }

  onMouseDown = (e) => {
    // only left mouse button
    if (e.button !== 0) { return }
    const node = findDOMNode(this)

    this.setState({
      dragging: true,
      rel: {
        yPrime: e.pageY - node.scrollTop,
        yCenterPrime: this.state.yCenter
      }
    }, () => {
      window.addEventListener('mouseup', this.onMouseUp)
      window.addEventListener('mousemove', this.onMouseMove)
    })

    document.body.classList.add(styles.dragActive)
  }

  onMouseUp = () => {
    this.setState(
      {dragging: false},
      () => window.removeEventListener('mousemove', this.onMouseMove)
    )
    document.body.classList.remove(styles.dragActive)
    this.props.onCenterChange && this.props.onCenterChange(this.state.yCenter)
  }

  onMouseMove = (e) => {
    if (!this.state.dragging) {
      console.log('onMouseMove event fired outside of drag interaction')
      return
    }
    const {yPrime, yCenterPrime} = this.state.rel
    const pixelDiff = e.pageY - yPrime
    const percentageDiff = pixelDiff / this.height()
    const yCenter = this.clampYCenter(yCenterPrime - percentageDiff)
    this.setState({yCenter})
  }

  height = () => {
    const vw = window.innerWidth
    return vw / this.state.aspect
  }

  croppedHeight = () => {
    const height = this.height()
    const vh = window.innerHeight
    return Math.min(
      vh * 0.8,
      height,
      600
    )
  }

  clampYCenter = (yc) => {
    const height = this.height()
    const croppedHeight = this.croppedHeight()
    const yCenterMin = croppedHeight / (2 * height)
    const yCenterMax = 1 - yCenterMin
    return Math.max(Math.min(yCenterMax, yc), yCenterMin)
  }

  setAspect = () => {
    this.setState({aspect: this._img.naturalWidth / this._img.naturalHeight})
  }

  setImg = (img) => {
    this._img = img
  }

  render () {
    console.log('rerender')
    const {src} = this.props
    const {yCenter, dragging} = this.state

    const height = this.height()
    const croppedHeight = this.croppedHeight()

    const oPrime = (height * yCenter - croppedHeight / 2)
    const oMin = 0
    const oMax = height - croppedHeight
    // prevent a negative offsetTop (white showing at top of image)
    const o = Math.min(oMax, Math.max(oMin, oPrime))

    return (
      <div className={styles.FullWidthImage} style={{height: croppedHeight}}>
        <img draggable='false'
          ref={this.setImg}
          onLoad={this.setAspect}
          className={dragging && styles.dragActive}
          src={src}
          style={{top: -o + 'px'}}
          onMouseDown={this.onMouseDown} />
      </div>
    )
  }
}
